import {NgModule} from '@angular/core';
import {AuthComponent} from './auth.component';
import {RouterModule, Routes} from "@angular/router";
import {SignInComponent} from "./components/sign-in/sign-in.component";
import {ForgetPasswordComponent} from "./components/forget-password/forget-password.component";
import {AuthPathEnum} from "./@application/enums/auth-path.enum";
import {ForgetVerifyComponent} from "./components/forget-verify/forget-verify.component";
import {SignUpComponent} from "./components/sign-up/sign-up.component";
import {SignupVerifyComponent} from "./components/signup-verify/signup-verify.component";
import { VendorsModule } from '../../../vendors/src/lib/vendors.module';
import {CommonModule} from "@angular/common";

const routes: Routes = [
  {path: '', component: SignInComponent},
  {path: AuthPathEnum.Forget_Password, component: ForgetPasswordComponent},
  {path: AuthPathEnum.Forget_Password_Verify, component: ForgetVerifyComponent},
  {path: AuthPathEnum.Signup, component: SignUpComponent},
  {path: AuthPathEnum.Signup_Verify, component: SignupVerifyComponent},
]

@NgModule({
  declarations: [
    AuthComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    VendorsModule,
    CommonModule,
  ],
  exports: [
    AuthComponent
  ]
})
export class AuthModule {
}
